import {
  AutocompleteInput,
  BooleanField,
  Datagrid,
  List,
  NumberField,
  ReferenceInput,
  SelectInput,
  TextField,
  TextInput,
} from 'react-admin';
import { PLACE_TYPE_CHOICES, PLACE_REGION_CHOICES } from './PlacesCreate';

const searchFilters = [
  <TextInput source="name@ilike" alwaysOn label="Name" />,
  <SelectInput source="type" choices={PLACE_TYPE_CHOICES} alwaysOn />,
  <SelectInput source="region" choices={PLACE_REGION_CHOICES} alwaysOn />,
  <ReferenceInput source="parent_id" reference="places">
    <AutocompleteInput
      optionText="name"
      filterToQuery={(searchText) => ({ 'name@ilike': searchText })}
      label="Sections Of"
      fullWidth
    />
  </ReferenceInput>,
];

export const PlacesList = () => {
  return (
    <List filters={searchFilters} sort={{ field: 'name', order: 'ASC' }}>
      <Datagrid rowClick="edit" bulkActionButtons={false}>
        <NumberField source="id" />
        <TextField source="name" />
        <TextField source="abbreviation" />
        <TextField source="type" />
        <TextField source="region" />
        <TextField source="city" />
        <TextField source="state" label="Province" />
        <TextField source="phone_number" />
        <BooleanField source="active" />
      </Datagrid>
    </List>
  );
};
